import { render, staticRenderFns } from "./SuperadminCreatePage.vue?vue&type=template&id=60d791fc&scoped=true&"
import script from "./SuperadminCreatePage.vue?vue&type=script&lang=js&"
export * from "./SuperadminCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./SuperadminCreatePage.vue?vue&type=style&index=0&id=60d791fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d791fc",
  null
  
)

export default component.exports